{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Salasana",
      "PLACEHOLDER": "Salasana",
      "ERROR": "Salasana on liian lyhyt."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Vahvista salasana",
      "ERROR": "Salasanat eivät täsmää."
    },
    "API": {
      "SUCCESS_MESSAGE": "Salasanan vaihtaminen onnistui.",
      "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
    },
    "CAPTCHA": {
      "ERROR": "Verification expired. Please solve captcha again."
    },
    "SUBMIT": "Lähetä"
  }
}
